import script from "./SearchWrite.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchWrite.vue?vue&type=script&lang=ts&setup=true"

import "./SearchWrite.vue?vue&type=style&index=0&id=e8bf540c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8bf540c"]])

export default __exports__